import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Header.css";
import AddPost from "../addPost/AddPost";
import Profile from "../profile/Profile";
import firebase from "firebase";
import { db, auth, storage } from "../service/firebase";

function Header() {
  const [progress, setProgress] = useState(0);
  const [caption, setCaption] = useState("");
  const [imagePost, setImagePost] = useState(null);
  const emailverified = auth?.currentUser?.emailVerified;

  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, []);

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setImagePost(e.target.files[0]);
    }
  };

  const uploadPost = () => {
    const storePost = storage
      .ref(`postImages/${imagePost.name}`)
      .put(imagePost);

    storePost.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        console.log(error);
        alert(error.message);
      },
      () => {
        storage
          .ref("postImages")
          .child(imagePost.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("posts")
              .add({
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                caption: caption,
                postImage: url,
                username: auth.currentUser.displayName,
              })
              .then(() => {
                console.log("success");
              })
              .catch((error) => {
                console.log(error.message);
                toast.error("Failed to add Post");
              });
            setProgress(0);
            setCaption("");
            setImagePost(null);
            toast.success("Post added successfully");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          });
      }
    );
  };

  return (
    <div className="d-flex justify-content-around align-items-center bg-primary row">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        closeOnClick
        draggable
        pauseOnFocusLoss
        pauseOnHover
      />
      <div className="col d-flex justify-content-between align-items-center">
        <img className="logo p-2" alt="logo" src="havkLogo.png"></img>
        <img className="logoName p-2" alt="logo" src="havkText.png"></img>
      </div>
      <div className="d-flex align-items-center justify-content-end col ">
        <div data-toggle="modal" data-target="#addPostModal">
          <AddPost />
        </div>
        <div
          className="modal fade"
          id="addPostModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {" "}
                  Add Post
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    {`${progress}%`}
                  </div>
                </div>
                <small id="passwordHelpBlock" className="form-text text-muted">
                  Choose only images
                </small>
                <div className="form-group mt-2">
                  <input
                    type="file"
                    disabled={!user}
                    onChange={handleChange}
                    className="form-control-file"
                    id="exampleFormControlFile1"
                  />
                </div>
                <div className="input-group flex-nowrap mt-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="addon-wrapping">
                      Caption
                    </span>
                  </div>
                  <input
                    type="text"
                    value={caption}
                    disabled={!user}
                    onChange={(e) => setCaption(e.target.value)}
                    className="form-control"
                    placeholder="Enter a caption..."
                    aria-label="Caption"
                    aria-describedby="addon-wrapping"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  onClick={uploadPost}
                  disabled={!emailverified}
                  className="btn btn-success"
                >
                  {" "}
                  Post{" "}
                </button>
                {user ? (
                  ""
                ) : (
                  <small
                    id="passwordHelpBlock"
                    className="form-text text-muted"
                  >
                    Login / SignUp to add Post
                  </small>
                )}
                {auth?.currentUser?.emailVerified ? (
                  ""
                ) : (
                  <small
                    id="passwordHelpBlock"
                    className="form-text text-muted"
                  >
                    verify your email to add post
                  </small>
                )}
              </div>
            </div>
          </div>
        </div>

        <Profile />
      </div>
    </div>
  );
}

export default Header;
